import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ProcessResultVh, Mllm } from "../types/output_vh";
import { MarkerData } from "features/results/ContentSection/Panels/VoiceHighlightPanel/HighlightPlayer";

interface ProcessVhState {
  results: Record<string, ProcessResultVh>; // key: documentId
  isLoading: boolean;
  error: string | null;
  _hasHydrated: boolean; // Rehydration status

  setResult: (documentId: string, result: ProcessResultVh) => void;
  setIsLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;

  // Computed values (to be refactored)
}

const initialState = {
  results: {},
  isLoading: false,
  error: null,
  _hasHydrated: false,
};

export const useProcessVhStore = create<ProcessVhState>()(
  persist(
    (set) => ({
      ...initialState,

      setResult: (documentId, result) =>
        set((state) => ({
          results: { ...state.results, [documentId]: result },
          isLoading: false,
          error: null,
        })),
      setIsLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error, isLoading: false }),
      reset: () => set(initialState),

      // These computed values need to be adapted to select a result by projectId
      getHighlightStats: () => [],
      getTotalHighlights: () => 0,
      getAudioInfo: () => ({ src: undefined, duration: 0, type: undefined }),
      getMllmInfo: () => null,
      getHighlightMarkers: () => [],
    }),
    {
      name: "process-vh-result-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !key.startsWith("_"))
        ),
      onRehydrateStorage: () => {
        setTimeout(() => {
          useProcessVhStore.setState({ _hasHydrated: true });
        }, 0);
      },
    }
  )
);
